import React from 'react'
import config from '../../config'

const Landing = () => {
  return (
    <iframe id="landing" src={config.LANDING_URL + '/guest.html'} style={{display: 'none'}}/>
  )
}

export default Landing



// WEBPACK FOOTER //
// ./src/state/landing/landing.js